<template>
    <input
        v-mask="config"
        :value="value"
        :name="name"
        :type="type"
        :placeholder="placeholder"
        :readonly="disabled"
        autocomplete="off"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @input="onInput"
    >
</template>

<script>
import mask from './directive'
import tokens from './tokens'
import masker from './masker'

export default {
    name: 'TheMask',
    directives: { mask },
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        mask: {
            type: [String, Array],
            required: true,
        },
        masked: {
            type: Boolean,
            default: false,
        },
        tokens: {
            type: Object,
            default: () => tokens
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text',
        },
        name: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            lastValue: null, // avoid unecessary emit when has no change
            display: this.value
        }
    },
    computed: {
        config() {
            return {
                mask: this.mask,
                tokens: this.tokens,
                masked: this.masked
            }
        }
    },
    watch: {
        value(newValue) {
            if (newValue !== this.lastValue) {
                this.display = newValue
            }
        },
        masked() {
            this.refresh(this.display)
        }
    },
    methods: {
        onInput(e) {
            if (e.isTrusted) return // ignore native event
            this.refresh(e.target.value)
        },
        refresh(value) {
            this.display = value
            value = masker(value, this.mask, this.masked, this.tokens)

            if (value !== this.lastValue) {
                this.lastValue = value
                this.$emit('input', value)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ext/the-mask/the-mask.vue